import { PrefixesMyAsNsOriginateSubscription } from "../../graphql/generated/operations";

export const formatter = (
  /** @type {PrefixesMyAsNsOriginateSubscription | undefined} */ data
) => data?.prefixes.map(({ network }) => network);
